export default {"src":"/_next/static/media/group_not_found.ad2e491c.svg","height":393,"width":526,"blurWidth":0,"blurHeight":0};